export default function DataEntryRoute() {
	return <p>Data Entry</p>
}
